import React, { useState } from 'react';
import { Section } from './ui/Section';
import { AccordionItem } from './ui/Accordion';
import { Gift } from 'lucide-react';
const bonos = [{
  icon: '🎮',
  title: 'BONO 1 — 100 JUEGOS Y ACTIVIDADES EN PISTA RESUELTOS',
  desc: '100 dinámicas lúdicas organizadas por edad y nivel para hacer tus clases más entretenidas, participativas y efectivas. Nunca más una clase aburrida.',
  value: '$12.000',
  includes: ['30 juegos para baby patín (4-6 años)', '30 juegos para infantil y juvenil (7-13 años)', '20 actividades para adolescentes y adultos', '20 juegos de coordinación y expression artística', 'Descripción, duración, objetivo y variantes']
}, {
  icon: '📅',
  title: 'BONO 2 — FICHAS DE CALENTAMIENTO Y VUELTA A LA CALMA',
  desc: '30 calentamientos listos para usar organizados por tipo y nivel + 15 rutinas de vuelta a la calma. Nunca más improvisar los primeros 15 minutos.',
  value: '$10.000',
  includes: ['10 calentamientos lúdicos (para niños)', '10 calentamientos técnicos (para intermedios)', '10 calentamientos deportivos (para avanzados)', '15 rutinas de vuelta a la calma y estiramiento', 'Tarjetas imprimibles para que los alumnos se autogestionen']
}, {
  icon: '📊',
  title: 'BONO 3 — KIT COMPLETO DE COMUNICACIÓN CON FAMILIAS',
  desc: 'Plantillas de mensajes de WhatsApp, circulares, informes de progreso y contratos listos para enviar. Profesionalizá tu comunicación sin esfuerzo.',
  value: '$10.000',
  includes: ['10 plantillas de mensajes de WhatsApp por situación', 'Circular de inicio de temporada', 'Circular de muestra y eventos', 'Modelo de contrato de inscripción', 'Reglamento interno de academia', 'Guía de manejo de padres difíciles']
}, {
  icon: '🎵',
  title: 'BONO 4 — BANCO DE MÚSICA PARA RUTINAS DE PATINAJE',
  desc: 'Lista curada de más de 80 canciones organizadas por categoría, edad, duración y estilo emocional. Encontrá la música perfecta para cada alumno.',
  value: '$9.000',
  includes: ['20 canciones para baby patín', '20 canciones para infantil y juvenil', '20 canciones para junior y senior', '20 músicas instrumentales para competencia', 'Cómo buscarlas en Spotify y editarlas gratis', 'Criterios para elegir la música perfecta']
}, {
  icon: '🩺',
  title: 'BONO 5 — PRIMEROS AUXILIOS Y PREVENCIÓN DE LESIONES',
  desc: 'Protocolo específico para las lesiones más comunes en patinaje artístico. Actuá con seguridad y profesionalismo ante cualquier situación en pista.',
  value: '$9.000',
  includes: ['Las 6 lesiones más frecuentes en patinaje', 'Protocolo de actuación paso a paso por lesión', 'Cómo enseñar a caer correctamente', 'Checklist de seguridad pre-clase', 'Ficha de consentimiento médico para familias', 'Cuándo derivar y cómo comunicarlo a los padres']
}, {
  icon: '🌟',
  title: 'BONO 6 — KIT DE INICIO PARA EL PROFE NUEVO',
  desc: 'Todo lo que necesitás para arrancar tu primera temporada con confianza y profesionalismo. La guía express que nadie te dio cuando empezaste.',
  value: '$8.000',
  includes: ['Checklist de las primeras 4 semanas', 'Cómo armar tus grupos por nivel y edad', 'Cómo fijar precios y cobrar sin culpa', 'Cómo hablar con los padres en la primera reunión', 'Los 10 errores del profe nuevo (y cómo evitarlos)', 'Plantilla de redes sociales para tu primer posteo']
}];
export function Bonos() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <Section dark className="bg-brand-dark" data-id="element-19">
      <div className="text-center mb-6 md:mb-12" data-id="element-20">
        <div className="inline-flex items-center justify-center bg-brand-accent text-brand-dark font-bold px-4 md:px-6 py-1.5 md:py-2 rounded-full mb-4 md:mb-6 text-sm md:text-base" data-id="element-21">
          <Gift className="w-4 h-4 md:w-5 md:h-5 mr-1.5 md:mr-2" data-id="element-22" />
          MÁS LOS 6 BONOS ESTRATÉGICOS GRATIS
        </div>
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-2 md:mb-4 text-white" data-id="element-23">
          Regalos Exclusivos
        </h2>
        <div className="w-16 md:w-24 h-1 bg-brand-accent mx-auto rounded-full mt-4 md:mt-6" data-id="element-24"></div>
      </div>

      <div className="max-w-4xl mx-auto mb-8 md:mb-12" data-id="element-25">
        {bonos.map((bono, index) => <AccordionItem key={index} dark isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} title={<div className="flex flex-col sm:flex-row sm:items-center justify-between w-full" data-id="element-27">
                <div className="flex items-center mb-1.5 sm:mb-0" data-id="element-28">
                  <span className="text-2xl md:text-3xl mr-2 md:mr-4" data-id="element-29">
                    {bono.icon}
                  </span>
                  <h3 className="text-sm md:text-xl font-bold text-white leading-tight" data-id="element-30">
                    {bono.title}
                  </h3>
                </div>
                <div className="flex items-center sm:ml-4 bg-brand-light px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-brand-dark/30" data-id="element-31">
                  <span className="text-brand-ice/60 line-through text-xs md:text-sm mr-1.5 md:mr-2" data-id="element-32">
                    Valor: {bono.value}
                  </span>
                  <span className="text-emerald-400 font-bold text-xs md:text-base" data-id="element-33">
                    GRATIS
                  </span>
                </div>
              </div>} data-id="element-26">
            <div className="pt-1 md:pt-2" data-id="element-34">
              <p className="text-sm md:text-lg font-medium text-brand-ice/90 mb-4 md:mb-6 italic border-l-4 border-brand-accent pl-3 md:pl-4" data-id="element-35">
                "{bono.desc}"
              </p>
              <h4 className="font-bold text-white mb-3 md:mb-4 text-sm md:text-base" data-id="element-36">
                Incluye:
              </h4>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3" data-id="element-37">
                {bono.includes.map((item, i) => <li key={i} className="flex items-start" data-id="element-38">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-accent mt-1.5 md:mt-2 mr-2 flex-shrink-0" data-id="element-39"></div>
                    <span className="text-xs md:text-base text-brand-ice/80" data-id="element-40">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </AccordionItem>)}
      </div>

      <div className="max-w-4xl mx-auto bg-gradient-to-r from-brand-accent/20 to-brand-accent/5 border border-brand-accent/30 p-5 md:p-8 rounded-xl md:rounded-2xl text-center" data-id="element-41">
        <h3 className="text-lg md:text-2xl font-bold text-white mb-1 md:mb-2" data-id="element-42">
          Valor total de los 6 bonos:{' '}
          <span className="line-through text-brand-ice/60" data-id="element-43">$58.000</span>
        </h3>
        <p className="text-2xl md:text-3xl font-serif font-bold text-brand-accent uppercase tracking-widest" data-id="element-44">
          GRATIS
        </p>
        <p className="text-xs md:text-base text-brand-ice/80 mt-1 md:mt-2" data-id="element-45">
          Incluidos siempre en las dos ofertas
        </p>
      </div>
    </Section>;
}